import { BroadcastCheckResultDto } from '@upme/contracts';
import { HTTPError } from 'ky';

/** Тело ошибки трансляции: `{ code, message, check? }` (бэкенд #146, 4xx и 503). */
export interface BroadcastApiError {
  status: number;
  code: string | null;
  message: string;
  check: BroadcastCheckResultDto | null;
}

/** parseHttpError из @upme/api-client теряет code и check — поэтому свой разбор. null — не HTTP-ошибка (сеть). */
export async function readBroadcastError(err: unknown): Promise<BroadcastApiError | null> {
  if (!(err instanceof HTTPError)) return null;
  const status = err.response.status;
  try {
    const body = (await err.response.clone().json()) as {
      code?: unknown;
      message?: unknown;
      check?: unknown;
    };
    const check = BroadcastCheckResultDto.safeParse(body.check);
    return {
      status,
      code: typeof body.code === 'string' ? body.code : null,
      message: typeof body.message === 'string' ? body.message : err.message,
      check: check.success ? check.data : null,
    };
  } catch {
    return { status, code: null, message: err.message, check: null };
  }
}

/** Текст для тоста: готовое сообщение бэкенда; сеть и 5xx без code — fallback. */
export function broadcastErrorText(apiErr: BroadcastApiError | null, fallback: string): string {
  if (!apiErr) return fallback;
  if (apiErr.code === null && apiErr.status >= 500) return fallback;
  return apiErr.message;
}
